import React, { useState, useCallback, useEffect } from 'react';
import useApi from '../../api/useApi';

function index({ handleClose, showNotification }) {
  const passwordDataModel = {
    oldPwd: '',
    newPwd: '',
    confirmPwd: '',
  };

  const [passwordData, setPasswordData] = useState(passwordDataModel);
  const [passwordState, changePassword] = useApi();

  const handlePasswordInputChange = useCallback((e) =>
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value })
  );

  const handlePasswordChange = (e) => {
    e.preventDefault();

    let err = [];

    if (!passwordData.oldPwd) err.push('Old Password');
    if (!passwordData.newPwd) err.push('New Password');
    if (!passwordData.confirmPwd) err.push('Confirm Password');

    if (err.length > 0) {
      showNotification('error', `Please fill ${err.join(', ')} field(s)`);
      return;
    }

    if (passwordData.confirmPwd !== passwordData.newPwd) {
      showNotification('error', `Confirm Password should match New Password`);
      return;
    }

    const body = {
      oldPassword: passwordData.oldPwd,
      newPassword: passwordData.newPwd,
    };

    changePassword('/changePassword', 'POST', body);
  };

  useEffect(() => {
    if (!passwordState.isLoading && !passwordState.isError && passwordState.data) {
      showNotification('success', 'Password updated successfully');
    }
    if (passwordState.isError) {
      showNotification('sucerrorcess', passwordState.data);
    }
  }, [passwordState]);

  return (
    <div>
      {/* <p className="mt-4 font-bold text-lg text-textBlue1">Change Password</p> */}
      <form className="mt-3 flex flex-wrap" onSubmit={handlePasswordChange} autoComplete="off">
        <div className=" w-11/12 items-center ml-3 my-2">
          {/* <label htmlFor="oldPwd" className="mb-1 block text-parameter  text-sm">
            OLD PASSWORD
          </label> */}
          <input
            type="password"
            value={passwordData.oldPwd}
            name="oldPwd"
            placeholder="Old Password"
            className="rounded-lg w-full bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className=" w-11/12 items-center ml-3 my-2">
          {/* <label htmlFor="newPwd" className="mb-1 block text-parameter  text-sm">
            NEW PASSWORD
          </label> */}
          <input
            type="password"
            value={passwordData.newPwd}
            name="newPwd"
            placeholder="New Password"
            className="rounded-lg w-full bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className=" w-11/12 items-center ml-3 my-2">
          {/* <label htmlFor="confirmPwd" className="mb-1 block text-parameter  text-sm">
            CONFIRM PASSWORD
          </label> */}
          <input
            type="password"
            value={passwordData.confirmPwd}
            name="confirmPwd"
            placeholder="Confirm Password"
            className="rounded-lg w-full bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
            onChange={handlePasswordInputChange}
          />
        </div>

        <div className="flex w-full items-center justify-end  mt-6 relative">
          {passwordState.isLoading ? (
            <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto" alt="" />
          ) : (
            <div className="flex text-xs relative mb-4 mr-4 right-0">
              <button
                type="submit"
                onClick={() => handleClose()}
                className="rounded-3xl border focus:outline-none w-28 h-8 mr-3 cursor-pointer "
                // style={{ border: '1px solid #16406D' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-3xl focus:outline-none w-28 h-8 text-white cursor-pointer"
                style={{ background: '#16406D' }}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

export default index;
